import { Button, ButtonProps } from "@mui/material";
import { useRoute } from "hooks/useRoute";

export const SecureButton = (props: ButtonProps & { href: string }): JSX.Element => {
  const { isAvailable, navigate } = useRoute({ path: props.href });

  if (!isAvailable) {
    return <></>;
  }

  const newProps = { ...props, onClick: navigate, href: undefined };

  return <Button {...newProps} />;
};
